/* eslint-disable @typescript-eslint/no-explicit-any */
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';

import Axios from '@/lib/axios-instance';

type APIPayload = {
    title: string,
    message: string,
    url: string,
    is_active: boolean,
    delay: number,
    scrawl_percentage: number
};

type ResponseType = {
    data: any;
    meta: any;
};

export const AddProactiveChatBulk = async (payload: APIPayload[]) => {
    try {
        const response = await Axios.post(`/pro_active_chats/bulk-save`, payload);
        return response.data;
    } catch (error: any) {
        if (error.response) {
            throw new Error(
                `${error.response.data?.meta?.message || 'An error occurred'}`,
            );
        }
        throw new Error(error.message || 'Network Error');
    }
};

export const useAddProactiveChatBulk = () => {
    const queryClient = useQueryClient();
    return useMutation<ResponseType, Error, APIPayload[]>({
        mutationFn: (payload) => AddProactiveChatBulk(payload),
        onSuccess: (data) => {
            toast.success('Proactive Chat Added Successfully');
            queryClient.invalidateQueries({ queryKey: ['get_proactive_chats'] });
            console.log(data);
        },
        onError: (error) => {
            toast.error('Adding Proactive Chat Failed', {
                description: error.message,
            });
        },
    });
};
